import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';

import { MarketPlaceQuoteRequestService } from 'src/app/services/market-place-quote-request-service/market-place-quote-request.service';
import { REQUEST_STEPS } from 'src/app/routes/search-inventory-component/request-quote-component/enum-request-steps';
import { OptionModel } from 'src/app/models/railcar-display-options.model';
import { RailCar } from 'src/app/models/railcar.model';
import { StccsOption } from 'src/app/models/stcc-option.model';
import { MixpanelService } from '../../../services/mixpanel-service/mixpanel.service';

@Component({
  selector: 'app-display-segment',
  templateUrl: './display-segment.component.html',
  styleUrls: ['./display-segment.component.scss'],
})
export class DisplaySegmentComponent implements OnChanges {
  @Input() displayedCars: RailCar[] = [];
  @Input() cardAttrList: OptionModel[] = [];
  @Input() detailAttrList: OptionModel[] = [];
  @Input() matchCt = 0;
  @Input() CarType: any = {};
  @Input() activeStcc: StccsOption | undefined;
  @Input() productName: string = '';
  @Input() banner: {
    enabled: boolean;
    message: string;
    header?: string;
    color: string;
  } = {
    enabled: false,
    message: '',
    color: '',
  };

  @Output() disableBanner: EventEmitter<any> = new EventEmitter();
  @Output() displayFilter: EventEmitter<any> = new EventEmitter();

  selectedNum = 0;
  selectedCars: { [x: string]: RailCar } = {};
  isDisplayingDialog = false;
  detailViewObj: any | undefined;
  ValidationFilterMobile = false;

  constructor(
    public quoteRequestService: MarketPlaceQuoteRequestService,
    private mixpanelService: MixpanelService,
    public router: Router
  ) {}

  ngOnInit(): void {
    const { selectedCars } = this.quoteRequestService.getSelectedCarList();
    selectedCars.forEach((car) => {
      this.selectedCars[car.model_id] = car;
    });
    this.selectedNum = Object.keys(this.selectedCars).length;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['displayedCars']) {
      this.clearRemovedCards();
    }
  }

  beginQuoteReqEnabled(): boolean {
    return (
      this.stccValid() &&
      this.CarType.values !== undefined &&
      !this.quoteRequestService.gettingCarList() &&
      (this.displayedCars.length === 0 ||
        Object.keys(this.selectedCars).length > 0)
    );
  }
  stccValid(): boolean {
    if (this.activeStcc === undefined) {
      return false;
    }
    return this.activeStcc.stcc !== 'Other' || this.productName?.length > 0;
  }

  disableBannerFn(): void {
    this.disableBanner.emit();
  }

  cardToggled({ car, selected }: { car: RailCar; selected: boolean }) {
    const key = `${car.model_id}_${car.status}`;
    if (selected) {
      this.selectedCars[key] = car;
    } else {
      delete this.selectedCars[key];
    }
    this.selectedNum = Object.keys(this.selectedCars).length;
  }

  selectAll(): void {
    if (this.displayedCars.length === 0 || this.activeStcc === undefined) {
      return;
    }

    const allActive = this.selectedNum === this.displayedCars.length;
    if (allActive) {
      this.selectedCars = {};
    } else {
      this.displayedCars.forEach((car) => {
        if (car.model_id && car.status) {
          const key = `${car.model_id}_${car.status}`;
          this.selectedCars[key] = car;
        }
      });
    }

    this.selectedNum = Object.keys(this.selectedCars).length;
  }

  clearRemovedCards(): void {
    Object.keys(this.selectedCars).forEach((model_id) => {
      if (this.displayedCars.some((x) => `${x.model_id}` === model_id)) {
        return;
      }
      delete this.selectedCars[model_id];
    });
    this.selectedNum = Object.keys(this.selectedCars).length;
  }

  openModel(car: any): void {
    this.isDisplayingDialog = true;
    this.detailViewObj = car;
  }

  closeModel(): void {
    this.isDisplayingDialog = false;
    this.detailViewObj = undefined;
  }

  beginQuoteRequest(): void {
    const userEmail = localStorage.getItem('userEmail') || '';
    this.mixpanelService.trackBeginTime(
      'Begin Quote Button Click Time',
      userEmail
    );
    this.mixpanelService.track({
      id: userEmail,
      eventName: 'Begin Quote',
      eventDisplayName: 'Begin Quote Request',
      kpi: 'User Engagement',
      trigger: 'On Button Click',
      eventDefinition: 'User is ready to start quoting process',
      propertyType: 'Event Property',
      propertyDefinition: 'Button Quote Submit',
    });
    if (!this.beginQuoteReqEnabled()) {
      return;
    }
    const selectedCarsArr = Object.entries(this.selectedCars).map((x) => x[1]);
    this.quoteRequestService.setSelectedCarList(
      selectedCarsArr,
      this.cardAttrList
    );
    this.quoteRequestService.setNextStep(REQUEST_STEPS.SELECTION);
    localStorage.removeItem('fromNewBuilds');
    this.router.navigate(['/search-inventory/request-quote'], { state: {} });
  }
  openFilterbox() {
    this.displayFilter.emit();
  }
  showValidation(event: any) {
    this.ValidationFilterMobile = true;
  }
}
